export default __webpack_public_path__ + "static/media/iphone.65349739.svg";